import axios from 'axios';
import {
  showErrorModal,
  showExpiredSessionModal,
} from '@/redux/slices/modalAlertSlice';
import store from '@/redux/store';
import { msalInstance } from './msal';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { addOriginGuard } from './axiosOriginGuard';

let apiController = new AbortController();
const apiNl = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL,
});

addOriginGuard(apiNl);

apiNl.defaults.headers.common = {
  'Content-Encoding': 'gzip',
};

apiNl.interceptors.request.use((config) => {
  const account = msalInstance.getAllAccounts()[0];
  return msalInstance
    .acquireTokenSilent({
      scopes: [import.meta.env.VITE_AZUREAD_CLIENTID],
      account: account,
    })
    .then((response) => {
      const accessToken = response.accessToken;
      config.headers.Authorization = `Bearer ${accessToken}`;
      return config;
    })
    .catch((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: [import.meta.env.VITE_AZUREAD_CLIENTID],
          account,
        });
      } else {
        store.dispatch(showExpiredSessionModal(true));
      }
      if (import.meta.env.DEV) {
        console.error('Error acquiring token:', error);
      }
      return Promise.reject(error);
    });
});

apiNl.interceptors.response.use(
  (response) => {
    //End the response
    return response;
  },
  (error) => {
    if (error.code !== 'ERR_CANCELED') {
      store.dispatch(
        showErrorModal(error.message, error.response?.data?.error),
      );
    }
    //Error managment
    return Promise.reject(error);
  },
);

const restartApiCotroller = () => {
  apiController = new AbortController();
};

export { apiNl, apiController, restartApiCotroller };
